import { Box, useTheme } from '@vitvio/design-system';

interface ContentProps {
  children: React.ReactNode;
}

export function Content({ children }: ContentProps) {
  const { getColor } = useTheme();
  return (
    <Box
      bg={getColor('bg')}
      borderRadius={'inherit'}
      display={'flex'}
      flexDir={'column'}
      overflow={'scroll'}
      minHeight={'100%'}
      position={'relative'}
    >
      {children}
    </Box>
  );
}
